import { render } from "./detail_product.vue?vue&type=template&id=083c6358&scoped=true"
import script from "./detail_product.vue?vue&type=script&lang=js"
export * from "./detail_product.vue?vue&type=script&lang=js"

import "./detail_product.vue?vue&type=style&index=0&id=083c6358&lang=scss&scoped=true"

import exportComponent from "F:\\Code3\\hwh-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-083c6358"]])

export default __exports__